export enum FolderFileType {
    Folder = 0,
    File = 1,
}

export enum GlobalSearchType {
    Folder = 0,
    File = 1,
    Menu = 2
}

export enum MessagePriority {
    High = 1,
    Low = 2,
    Normal = 3
}

export enum FileActions {
    Download = "Download",
    AddNew = "Add new",
    Edit = "Edit",
    Publish = "Publish",
    UndoPublish = "Undo publish",
    ShareToRole = "Share to roles",
    ShareToUser = "Share to users",
    MakeACopy = "Make a copy",
    MoveToBin = "Delete",
}

export enum LoggerType {
    FrontEnd = "FrontEnd",
    Api = "API"
}

export enum NotificationType {
    Email = 1,
    Sms = 2,
    InApp = 3
}
